<div edsGrid>
  <div class="container">
    <div edsRow>
      <div edsCol>
        <div edsPadding edsPaddingAll="lg">
          <div edsSpacing="lg">
            <eds-image
              imgSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
              imgFallbackSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
            >
            </eds-image>
          </div>
          <eds-title edsSpacing="sm" size="h3" theme="dark">
            {{
              "literature.lit-listing-no-search-result-message-start"
                | translate
            }}
            {{ searchKey }}
            {{
              "literature.lit-listing-no-search-result-message-end" | translate
            }}
          </eds-title>
          <eds-title edsSpacing="sm" size="h6" theme="dark">
            {{
              "literature.lit-listing-no-search-result-message-suggestion"
                | translate
            }}
          </eds-title>
          <ul
            class="list--unordered"
            edsList
            innerHTML="{{
              'literature.lit-listing-no-search-result-message-list' | translate
            }}"
          ></ul>
        </div>
      </div>
    </div>
  </div>
</div>
